import SectionWithItems from "../../../scripts/SectionWithItems";
import experiences from "../../../data/experience";

const LandingExperience = () =>{
    return (
        <SectionWithItems title='Experience' projects={experiences} />
    )
}

export default LandingExperience;
